import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsCustom4Route: InvariantJiraRoute = {
	name: 'servicedesk-reports-custom',
	path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId',
};
